<template>
  <RouterLink :to="to" :class="$style.directionalLink">
    <IconAngle
      :class="[
        $style.directionalLink__angle,
        { [$style['directionalLink__angle--reverse']]: direction === 'prev' },
      ]"
    />
    {{ text }}
  </RouterLink>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import IconAngle from '@/components/icons/IconAngle.vue'
import type { RouteLocationRaw } from 'vue-router'

type Direction = 'next' | 'prev'

export default defineComponent({
  name: 'DirectionalLink',
  components: { IconAngle },
  props: {
    text: {
      type: String,
      required: true,
    },
    to: {
      type: Object as PropType<RouteLocationRaw>,
      required: true,
    },
    direction: {
      type: String as PropType<Direction>,
      default: 'next',
      validator: (value: string): value is Direction =>
        ['next', 'prev'].includes(value),
    },
  },
})
</script>

<style lang="scss" module>
.directionalLink {
  display: inline-flex;
  align-items: center;
  color: $color-text-and-object-accent-primary;
  font-size: 14px;

  &__angle {
    margin-right: 0.2em;
    color: $color-text-and-object-medium-emphasis;

    &--reverse {
      transform: rotate(180deg);
    }
  }

  &:hover {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
